import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { get1DDataXY } from '../../data/data1d/Spectrum1D/get1DDataXY';
import { useChartData } from '../context/ChartContext';
import { useActiveSpectrum } from '../reducer/Reducer';
import Line from './Line';
function LinesSeries() {
    const { data, tempData, displayerKey, xDomains } = useChartData();
    const activeSpectrum = useActiveSpectrum();
    let _data = tempData || data;
    return (_jsxs("g", { clipPath: `url(#${displayerKey}clip-chart-1d)`, className: "spectrums", children: [_data
                ?.filter((d) => d.display.isVisible === true && xDomains[d.id])
                .map((d, i) => (_jsx("g", { id: d.id, children: _jsx(Line, { display: d.display, id: d.id, data: get1DDataXY(d), index: i }) }, d.id))), activeSpectrum?.id && _jsx("use", { href: `#${activeSpectrum?.id}` })] }));
}
export default LinesSeries;
